import { getCurrency } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const PackageSummaryTotals = (props) => {
  const { subTotal, settings } = props;
  return (
    <>
      <div className="c7-cart-summary">
        <div className="c7-cart-summary__total">
          <div>Subtotal:</div>
          <div>
            <span>{getCurrency(settings)}</span>{' '}
            {currencyFormat(subTotal, settings)}
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageSummaryTotals;
